import { Action, createReducer, on } from '@ngrx/store';
import * as SystemActions from './system.actions';

export type FonteConsultaImoveis =
  | 'portal_info_lote'
  | 'legado'
  | 'criciuma';

export interface PortalDocumentosLayerConfig {
  habilitar?: boolean;
  publico?: boolean;
}

/**
 * Visibilidade dos documentos (mídia tipo 2 e tipo 3 não-imagem) no portal
 * ICAD. Chaves de `camadas` são `String(projetos_camadas.id)`; o valor por
 * camada sobrepõe o do tenant campo a campo. Ausência mantém o comportamento
 * atual (documentos visíveis para todos). Gravado pelo Geo360.
 */
export interface PortalDocumentosConfig extends PortalDocumentosLayerConfig {
  camadas?: Record<string, PortalDocumentosLayerConfig | undefined>;
}

export interface TenantConfig {
  tipo?: string;
  api?: {
    api_geomais?: boolean | string;
  };
  bucket?: string;
  cidade?: string;
  idICAD?: number;
  proj?: string;
  tenantExtent?: any[];
  terms?: {
    title?: string;
    textHtml?: string;
  };
  consultaPreviaPortal?: {
    textoArea?: string;
    campoArea?: string;
  };
  nomeColunaTipologia?: string;
  regressao_multipla_ouv?: string[];
  tabela_unidade?: string;
  checkTerrenoBaldio?: {
    nome_campo: string;
    valor_baldio: string;
  };
  observatorio?: any;
  showLayersInteractionButton?: boolean;
  aliquotaITBI?: number;
  pesquisaAvancada?: {
    labels?: {
      abaImoveis?: string;
      abaLogradouros?: string;
      abaEndereco?: string;
      numeroCadastro?: string;
      inscricaoImobiliaria?: string;
      nomeProprietario?: string;
      cpfCnpj?: string;
      codigo?: string;
      nome?: string;
      nomeRua?: string;
      numeroCasa?: string;
      bairro?: string;
      quadra?: string;
      lote?: string;
      botaoPesquisar?: string;
    };
  };
  portalConfig?: {
    fonteConsultaImoveis?: FonteConsultaImoveis;
    ortofotoInBaseMapSection?: boolean;
    habilitaHierarquiaPastasCamadas?: boolean;
    habilitarMidiaOutrasCamadas?: boolean;
    desabilitarPriorizarLote?: boolean;
    abrirRelatoriosPdfEmNovaAba?: boolean;
    relatorios?: {
      nome: string;
      tipo: string;
      publico?: boolean;
      somentePublico?: boolean;
    }[];
    documentos?: PortalDocumentosConfig;
  };
  habilitarPastasMapaBase?: boolean;
  formulaV2?: boolean;
  geracaoRotas?: boolean;
}

export interface State {
  tenantConfig: TenantConfig | string | null;
  isLoading: boolean;
  error: any | null;
}

export const initialState: State = {
  tenantConfig: null,
  isLoading: false,
  error: null,
};

const systemReducer = createReducer(
  initialState,
  on(SystemActions.getTenantConfig, (state: State) => ({
    ...state,
    isLoading: true,
  })),
  on(
    SystemActions.getTenantConfigSuccess,
    (state: State, { tenantConfig }: { tenantConfig: TenantConfig }) => ({
      ...state,
      tenantConfig: {
        ...tenantConfig,
        api: {
          ...tenantConfig?.api,
          api_geomais:
            tenantConfig?.api?.api_geomais === 'true' ||
            tenantConfig?.api?.api_geomais === true
            ? true
            : false,
        },
      },
      isLoading: false,
    })
  ),
  on(
    SystemActions.getTenantConfigFail,
    (state: State, { error }: { error: any }) => ({
      ...state,
      tenantConfig: null,
      isLoading: false,
      error,
    })
  )
);

export function reducer(state: State | undefined, action: Action) {
  return systemReducer(state, action);
}

export const getTenantConfig = (state: State) =>
  state.tenantConfig as TenantConfig;
